import type IUsersRepository from '@/core/domain/users/IUsersRepository.ts'

export default class SendEmailResetPasswordUseCase {
  private readonly userRepository: IUsersRepository

  constructor(userRepository: IUsersRepository) {
    this.userRepository = userRepository
  }

  async execute(identifier: string): Promise<boolean> {
    return await this.userRepository.sendEmailResetPassword(identifier)
  }
}